import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { Button } from 'reactstrap';
import { translate } from 'react-switch-lang';
import ConversationItem from './ConversationItem';
import chatStorage from './chatStorage';
import usersStorage from '../Users/usersStorage';
import conversationsList from '../../../mocks/conversations';

class ConversationsList extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <div className="flex-col users">
        <ul className="users-list__container flex-col">
          {chatStorage
            .conversationsList
            .slice(0, chatStorage.listLimit)
            .map((item) => <ConversationItem key={item.id.toString()} {...item} />)}
          {chatStorage.conversationsList.length > 0 && (
            <li className="user-list__item flex-row">
              <div style={{ color: 'black' }}>
                <Button onClick={chatStorage.loadMore}>{t('Load more')}</Button>
              </div>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

ConversationsList.propTypes = {};

export default translate(observer(ConversationsList));
